import { useMemo } from 'react'
import { useEthPrice } from '@components/Web3/useEthPrice'
import { useUSDCMetadata } from '@components/Web3/UserOpTxModal/usdc/qr-fund/useUSDCAddress'
import { combineEthAndUsdcInUsd } from 'hooks/useFormattedNormalizedTipAmount'
import { ETH_ADDRESS, useSpaceTips } from 'use-towns-client'

export function useUSDTotalSpaceTips(args: { spaceId: string; noDecimals?: boolean }) {
    const { spaceId, noDecimals } = args
    const { address: usdcAddress } = useUSDCMetadata()
    const { data: ethPrice } = useEthPrice()
    const { data: tips, isLoading } = useSpaceTips({
        spaceId,
        currencies: [ETH_ADDRESS, usdcAddress],
    })

    return useMemo(() => {
        const ethTips = tips?.find((t) => t.currency.toLowerCase() === ETH_ADDRESS.toLowerCase())
        const usdcTips = tips?.find((t) => t.currency.toLowerCase() === usdcAddress.toLowerCase())

        return {
            isLoading,
            usdTotal: combineEthAndUsdcInUsd({
                ethAmount: ethTips?.amount ?? 0n,
                usdcAmount: usdcTips?.amount ?? 0n,
                ethPrice,
                opts: { noDecimals },
            }),
        }
    }, [tips, isLoading, ethPrice, noDecimals, usdcAddress])
}
